import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}


export class UsageWidgetErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  /**
   * Update state so the next render will show the fallback UI
   * This is called during the "render" phase, so side-effects are not permitted
   */
  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  /**
   * Reset error state to retry rendering the component
   */
  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div 
          className="usage-widget-error p-4 bg-red-50 rounded"
          role="alert"
          data-testid="usage-widget-error-boundary"
        >
          <p className="text-red-800">Unable to load usage data</p>
          <button
            onClick={this.handleRetry}
            className="text-sm text-red-600 underline mt-2 hover:text-red-800 transition-colors"
            data-testid="error-boundary-retry-button"
          >
            Retry
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

